import {
    $get,
    $post
} from '@/utils/http'

export default {
    // 监督举报
    //网上举报
    getinternet(params) {
        return $post('/portal/websit/complainSeting/queryComplainOnLine', params)
    },
    // 二维码举报
    getqr(params) {
        return $post('/portal/websit/complainSeting/queryComplainRqCode', params)
    },
    // 工作评估列表
    getjbEV(params) {
        return $post('/portal/websit/jobAssessment/listJobAssessment', params)
    },
    // 问卷调查
    getquestionnaire(params) {
        return $post('/portal/websit/assessment/listAssessment', params)
    },
}
